import { render } from "./Unauthorize.vue?vue&type=template&id=f02fefde&ts=true"
import script from "./Unauthorize.vue?vue&type=script&lang=ts"
export * from "./Unauthorize.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__